module.exports = __webpack_public_path__ + "img/logo_panapass.efd0edd2.svg";